// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"245":"ec9a980ee9e216f89b7c","577":"218e053486a45f4660df"}[chunkId] + ".js";
};